import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useCallback, useMemo } from 'react';
export const useSearchModule = () => {
  var _params$get;
  const params = useSearchParams();
  const currentSearchTerm = (_params$get = params.get('search')) !== null && _params$get !== void 0 ? _params$get : '';
  const updateSearchQuery = useCallback(({
    query
  }) => {
    params.set('search', query);
    params.delete('page');
  }, [params]);
  const clearSearch = useCallback(() => {
    params.delete('search');
    params.delete('page');
  }, [params]);
  return useMemo(() => [{
    name: 'updateSearchQuery',
    function: updateSearchQuery,
    functionDescription: 'Update the search query to find products by keyword. Use short queries (2-3 keywords), not full sentences. Do not use search and filters at the same time.',
    functionParameters: {
      query: {
        type: 'string',
        currentValue: currentSearchTerm,
        description: 'The search query term'
      }
    },
    autoApplySetting: 'always-auto-apply'
  }, {
    name: 'clearSearch',
    function: clearSearch,
    functionDescription: 'Clear the current search query. Use this when the user wants to stop searching by keyword and just browse with filters.',
    functionParameters: {},
    autoApplySetting: 'always-auto-apply'
  }], [updateSearchQuery, clearSearch, currentSearchTerm]);
};